module.exports = __webpack_public_path__ + "static/media/22(1).3ffbfc12.jpg";